<div class="title">
    <div class="coldx">
        <h4>Firma Digitale</h4>
    </div>
</div>
<app-sign-document-form [document]="document"
                        (onSubmit)="doClose()" />
